<template>
  <div>
    <UpdateStockViaCSVModal
      v-if="showUpdateStockViaCSVModal"
      @hidden="showUpdateStockViaCSVModal = false"
      @updateDone="updateDone"
      :location="location"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Stock</h2>
          <p v-if="locationInfo">
            En este apartado se muestran los productos en stock de la tienda de
            {{ locationInfo.name }}.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de stock</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    @click="downloadStockCSV()"
                    >Descargar CSV</b-button
                  >

                  <b-button
                    class="ml-3"
                    @click="showUpdateStockViaCSVModal = true"
                    variant="primary"
                    >Actualizar vía CSV</b-button
                  >

                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:product="props">
                  <!-- Product and product attributes -->

                  <div
                    v-if="
                      props.row.product !== null &&
                      props.row.predefined_product === null
                    "
                  >
                    <div>
                      {{
                        `${props.row.product.reference} (${props.row.product.id})`
                      }}
                    </div>
                    <small
                      :key="attr.label"
                      v-for="(attr, i) in props.row.product_attributes"
                    >
                      {{ attr.label }}: {{ attr.selector_inputs.name
                      }}<span
                        v-if="i !== props.row.product_attributes.length - 1"
                        >{{ ',' }}
                      </span>
                    </small>
                  </div>

                  <!-- Predefined product -->
                  {{
                    props.row.product === null &&
                    props.row.predefined_product !== null
                      ? `${props.row.predefined_product.reference} (${props.row.predefined_product.id})`
                      : ''
                  }}

                  <!-- Free product -->
                  {{
                    props.row.product === null &&
                    props.row.predefined_product === null
                      ? `${props.row.product_attributes.reference} ${
                          props.row.product_attributes.description
                            ? `(${props.row.product_attributes.description})`
                            : ''
                        }`
                      : ''
                  }}
                </template>

                <template v-slot:product_images="props">
                  <div
                    v-bind:class="{
                      imageWrapperUniqueImg:
                        props.row.product_images.length === 1,
                      imageWrapperTwoImg: props.row.product_images.length === 2,
                    }"
                  >
                    <img
                      style="max-height: 100px; max-width: 100px"
                      v-bind:class="{
                        uniqueImg: props.row.product_images.length === 1,
                        leftImg:
                          props.row.product_images.length === 2 && index === 0,
                        rightImg:
                          props.row.product_images.length === 2 && index === 1,
                      }"
                      :src="image"
                      v-for="(image, index) in props.row.product_images"
                      :key="index"
                    />
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:created_by="props">
                  <span>{{
                    props.row.employee_first_name
                      ? props.row.employee_first_name
                      : '-'
                  }}</span>
                </template>

                <template v-slot:orders="props">
                  <div :key="order" v-for="order in props.row.order_set">
                    <b-link
                      :to="{
                        name: 'AdminOrdersEditScreen',
                        params: { id: order },
                      }"
                      >{{ order }}
                    </b-link>
                  </div>
                </template>

                <template v-slot:actions="props">
                  <b-button-group>
                    <b-button
                      :to="{
                        name: 'AdminStockLinesEditScreen',
                        params: { id: props.row.id },
                      }"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="eye-fill" aria-hidden="true" /> Histórico
                      <!-- / -->
                      <!-- <b-icon icon="pencil" aria-hidden="true" /> -->
                    </b-button>
                  </b-button-group>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';
import UpdateStockViaCSVModal from '@/admin/components/stock/UpdateStockViaCSVModal.vue';

export default {
  name: 'AdminStockLinesScreen',
  props: ['location'],
  components: { UpdateStockViaCSVModal },
  data() {
    return {
      showUpdateStockViaCSVModal: false,
      table: {
        url: uris.stockByLocationURI(this.location),
        selected: [],
        allSelected: false,
        columns: ['id', 'product', 'product_images', 'quantity', 'actions'],
        options: {
          sortable: [],
          headings: {
            product: 'Producto (ID)',
            product_images: 'Imagen',
            quantity: 'Cantidad en stock',
            // modified_at: 'Fecha modif.',
            id: 'ID de stock',
            orders: '# Venta',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
      locationInfo: null,
    };
  },
  created() {
    Promise.all([actions.getLocationById(this.location)]).then((x) => {
      this.locationInfo = x[0].data;
    });
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        Promise.all([actions.getLocationById(this.location)]).then((x) => {
          this.locationInfo = x[0].data;
        });

        this.table.url = uris.stockByLocationURI(this.location);
        // this.$refs.table.refresh();
      }
    );
  },
  filters: {
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    updateDone() {
      this.showUpdateStockViaCSVModal = false;
      this.$refs.table.refresh();
    },
    downloadStockCSV() {
      actions
        .postStockDownloadCSV(this.location)
        .then((x) => {
          // let fileName = 'stock.csv';

          let fileName = 'stock.xlsx';

          const url = window.URL.createObjectURL(new Blob([x.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((y) => {});
    },
    duplicateQuote(id) {
      actions.postQuoteDuplicate(id).then((x) => {
        this.$bvModal.msgBoxOk(`Presupuesto duplicado correctamente`);
        this.$refs.table.refresh();
      });
    },

    downloadQuote(id) {
      actions.downloadQuote(id).then((x) => {
        let fileName = 'Presupuesto.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeQuote(x);
    //   });
    // },
    removeQuote(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el presupuesto número ' + id + '?'
        )
      ) {
        actions
          .deleteQuote(id)
          .then((x) => {
            this.$refs.table.refresh();
          })
          .catch((err) => {
            if (
              err.response.status == 400 &&
              err.response.data === 'ERROR_PROTECTED'
            ) {
              alert(
                'No pudo eliminarse el presupuesto, ya que está asociado a un pedido'
              );
            }
          });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped>
.imageWrapperUniqueImg {
  position: relative;
  display: block;
  width: 100px;
  height: 100px;
  margin: auto;
}
.imageWrapperTwoImg {
  position: relative;
  display: block;
  width: 120px;
  height: 120px;
  margin: auto;
}
.uniqueImg {
  display: block;
}
.leftImg {
  display: block;
  max-width: 100px;
  max-height: 100px;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.rightImg {
  display: block;
  max-width: 100px;
  max-height: 100px;
  width: auto;
  height: auto;
  position: absolute;
  top: 20px;
  left: 20px;
}
</style>
